export class TipoCodigosProdutosANP {
    tipo: string;
    descricao: string;

    constructor(tipo?: string, descricao?: string) {
        this.tipo = tipo;
        this.descricao = descricao;
    }

    listar(): TipoCodigosProdutosANP[] {
        return [
            new TipoCodigosProdutosANP("810201001", "ÁLCOOL METÍLICO"),
            new TipoCodigosProdutosANP("820101001", "BIODIESEL B100"),
            new TipoCodigosProdutosANP("820101010", "BIODIESEL FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("610101009", "BRIGHT STOCK"),
            new TipoCodigosProdutosANP("210202003", "BUTADIENO"),
            new TipoCodigosProdutosANP("210202001", "BUTANO"),
            new TipoCodigosProdutosANP("210202002", "BUTANO ESPECIAL"),
            new TipoCodigosProdutosANP("620501002", "CICLO DIESEL"),
            new TipoCodigosProdutosANP("620501001", "CICLO OTTO"),
            new TipoCodigosProdutosANP("610101005", "CILINDRO I"),
            new TipoCodigosProdutosANP("610101006", "CILINDRO II"),
            new TipoCodigosProdutosANP("620601003", "CORRENTE DE MOTOSSERRA"),
            new TipoCodigosProdutosANP("340101002", "DERIVADOS LEVES INTERMEDIÁRIOS"),
            new TipoCodigosProdutosANP("560101002", "DERIVADOS PESADOS INTERMEDIÁRIOS"),
            new TipoCodigosProdutosANP("820101026", "DIESEL B S1800 PARA GERAÇÃO DE ENERGIA ELÉTRICA"),
            new TipoCodigosProdutosANP("820101032", "DIESEL B S50 PARA GERAÇÃO DE ENERGIA ELÉTRICA"),
            new TipoCodigosProdutosANP("820101027", "DIESEL B S500 PARA GERAÇÃO DE ENERGIA ELÉTRICA"),
            new TipoCodigosProdutosANP("820101004", "DIESEL B10"),
            new TipoCodigosProdutosANP("820101005", "DIESEL B15"),
            new TipoCodigosProdutosANP("820101022", "DIESEL B2 ESPECIAL - 200 PPM ENXOFRE"),
            new TipoCodigosProdutosANP("820101014", "DIESEL B20 S1800 - ADITIVADO"),
            new TipoCodigosProdutosANP("820101006", "DIESEL B20 S1800 - COMUM"),
            new TipoCodigosProdutosANP("820101031", "DIESEL B20 S50 ADITIVADO"),
            new TipoCodigosProdutosANP("820101030", "DIESEL B20 S50 COMUM"),
            new TipoCodigosProdutosANP("820101016", "DIESEL B20 S500 - ADITIVADO"),
            new TipoCodigosProdutosANP("820101015", "DIESEL B20 S500 - COMUM"),
            new TipoCodigosProdutosANP("820101025", "DIESEL B30"),
            new TipoCodigosProdutosANP("820101007", "DIESEL B4 S1800 - ADITIVADO"),
            new TipoCodigosProdutosANP("820101002", "DIESEL B4 S1800 - COMUM"),
            new TipoCodigosProdutosANP("820101009", "DIESEL B4 S500 - ADITIVADO"),
            new TipoCodigosProdutosANP("820101008", "DIESEL B4 S500 - COMUM"),
            new TipoCodigosProdutosANP("820101017", "DIESEL MARÍTIMO - DMA B2"),
            new TipoCodigosProdutosANP("820101018", "DIESEL MARÍTIMO - DMA B5"),
            new TipoCodigosProdutosANP("820101019", "DIESEL MARÍTIMO - DMB B2"),
            new TipoCodigosProdutosANP("820101020", "DIESEL MARÍTIMO - DMB B5"),
            new TipoCodigosProdutosANP("820101021", "DIESEL NÁUTICO B2 ESPECIAL - 200 PPM ENXOFRE"),
            new TipoCodigosProdutosANP("420201001", "DMA - MGO"),
            new TipoCodigosProdutosANP("420201003", "DMB - MDO"),
            new TipoCodigosProdutosANP("620101002", "ENGRENAGENS E SISTEMAS CIRCULATÓRIOS"),
            new TipoCodigosProdutosANP("620101007", "ESTAMPAGEM"),
            new TipoCodigosProdutosANP("210301001", "ETANO"),
            new TipoCodigosProdutosANP("810102001", "ETANOL ANIDRO"),
            new TipoCodigosProdutosANP("810102004", "ETANOL ANIDRO COM CORANTE"),
            new TipoCodigosProdutosANP("810102002", "ETANOL ANIDRO FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("810102003", "ETANOL ANIDRO PADRÃO"),
            new TipoCodigosProdutosANP("810101002", "ETANOL HIDRATADO ADITIVADO"),
            new TipoCodigosProdutosANP("810101001", "ETANOL HIDRATADO COMUM"),
            new TipoCodigosProdutosANP("810101003", "ETANOL HIDRATADO FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("210301002", "ETENO"),
            new TipoCodigosProdutosANP("210302004", "GÁS ÁCIDO"),
            new TipoCodigosProdutosANP("210101001", "GÁS COMBUSTÍVEL"),
            new TipoCodigosProdutosANP("210302003", "GÁS DE XISTO"),
            new TipoCodigosProdutosANP("210302002", "GÁS INTERMEDIÁRIO"),
            new TipoCodigosProdutosANP("210204001", "GÁS LIQUEFEITO INTERMEDIÁRIO"),
            new TipoCodigosProdutosANP("220101003", "GÁS NATURAL COMPRIMIDO"),
            new TipoCodigosProdutosANP("220101004", "GÁS NATURAL LIQUEFEITO"),
            new TipoCodigosProdutosANP("220101002", "GÁS NATURAL SECO"),
            new TipoCodigosProdutosANP("220101001", "GÁS NATURAL ÚMIDO"),
            new TipoCodigosProdutosANP("220101005", "GÁS NATURAL VEICULAR"),
            new TipoCodigosProdutosANP("220101006", "GÁS NATURAL VEICULAR PADRÃO"),
            new TipoCodigosProdutosANP("520101001", "GASÓLEOS"),
            new TipoCodigosProdutosANP("320101001", "GASOLINA A COMUM"),
            new TipoCodigosProdutosANP("320101003", "GASOLINA A FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("320101002", "GASOLINA A PREMIUM"),
            new TipoCodigosProdutosANP("320103001", "GASOLINA AUTOMOTIVA PADRÃO"),
            new TipoCodigosProdutosANP("320102002", "GASOLINA C ADITIVADA"),
            new TipoCodigosProdutosANP("320102001", "GASOLINA C COMUM"),
            new TipoCodigosProdutosANP("320102004", "GASOLINA C FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("320102003", "GASOLINA C PREMIUM"),
            new TipoCodigosProdutosANP("320201001", "GASOLINA DE AVIAÇÃO"),
            new TipoCodigosProdutosANP("320201002", "GASOLINA DE AVIAÇÃO FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("220102001", "GASOLINA NATURAL (C5+)"),
            new TipoCodigosProdutosANP("320301002", "GASOLINA PARA EXPORTAÇÃO"),
            new TipoCodigosProdutosANP("210203001", "GLP"),
            new TipoCodigosProdutosANP("210203002", "GLP FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("650101001", "GRAXAS MINERAIS"),
            new TipoCodigosProdutosANP("620101001", "HIDRÁULICO"),
            new TipoCodigosProdutosANP("610201001", "HIDROGENADO LEVE"),
            new TipoCodigosProdutosANP("610201002", "HIDROGENADO MÉDIO"),
            new TipoCodigosProdutosANP("610201003", "HIDROGENADO PESADO"),
            new TipoCodigosProdutosANP("620101004", "ISOLANTE TIPO A"),
            new TipoCodigosProdutosANP("620101005", "ISOLANTE TIPO B"),
            new TipoCodigosProdutosANP("220102002", "LÍQUIDO DE GÁS NATURAL"),
            new TipoCodigosProdutosANP("640201001", "MACROOLEOSAS"),
            new TipoCodigosProdutosANP("640101001", "MICROOLEOSAS"),
            new TipoCodigosProdutosANP("620502001", "MOTORES 2 TEMPOS"),
            new TipoCodigosProdutosANP("610101002", "NEUTRO LEVE"),
            new TipoCodigosProdutosANP("610401002", "NEUTRO LEVE RR"),
            new TipoCodigosProdutosANP("610101003", "NEUTRO MÉDIO"),
            new TipoCodigosProdutosANP("610401003", "NEUTRO MÉDIO RR"),
            new TipoCodigosProdutosANP("610101004", "NEUTRO PESADO"),
            new TipoCodigosProdutosANP("610401004", "NEUTRO PESADO RR"),
            new TipoCodigosProdutosANP("510101003", "ÓLEO COMBUSTÍVEL A FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("510101001", "ÓLEO COMBUSTÍVEL A1"),
            new TipoCodigosProdutosANP("510101002", "ÓLEO COMBUSTÍVEL A2"),
            new TipoCodigosProdutosANP("510102003", "ÓLEO COMBUSTÍVEL B FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("510102001", "ÓLEO COMBUSTÍVEL B1"),
            new TipoCodigosProdutosANP("510102002", "ÓLEO COMBUSTÍVEL B2"),
            new TipoCodigosProdutosANP("510201001", "ÓLEO COMBUSTÍVEL MARÍTIMO"),
            new TipoCodigosProdutosANP("510201002", "ÓLEO COMBUSTÍVEL MARÍTIMO FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("510201003", "ÓLEO COMBUSTÍVEL MARÍTIMO MISTURA (MF)"),
            new TipoCodigosProdutosANP("510301003", "ÓLEO COMBUSTÍVEL PARA GERAÇÃO ELÉTRICA"),
            new TipoCodigosProdutosANP("560101001", "ÓLEO DE XISTO"),
            new TipoCodigosProdutosANP("420105001", "ÓLEO DIESEL A S10"),
            new TipoCodigosProdutosANP("420101005", "ÓLEO DIESEL A S1800 - ADITIVADO"),
            new TipoCodigosProdutosANP("420101004", "ÓLEO DIESEL A S1800 - COMUM"),
            new TipoCodigosProdutosANP("420101003", "ÓLEO DIESEL A S1800 - FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("420102006", "ÓLEO DIESEL A S50"),
            new TipoCodigosProdutosANP("420102005", "ÓLEO DIESEL A S500 - ADITIVADO"),
            new TipoCodigosProdutosANP("420102004", "ÓLEO DIESEL A S500 - COMUM"),
            new TipoCodigosProdutosANP("420102003", "ÓLEO DIESEL A S500 - FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("420104001", "ÓLEO DIESEL AUTOMOTIVO ESPECIAL - ENXOFRE 200 PPM"),
            new TipoCodigosProdutosANP("820101033", "ÓLEO DIESEL B S10 - ADITIVADO"),
            new TipoCodigosProdutosANP("820101034", "ÓLEO DIESEL B S10 - COMUM"),
            new TipoCodigosProdutosANP("820101011", "ÓLEO DIESEL B S1800 - ADITIVADO"),
            new TipoCodigosProdutosANP("820101003", "ÓLEO DIESEL B S1800 - COMUM"),
            new TipoCodigosProdutosANP("820101028", "ÓLEO DIESEL B S50 - ADITIVADO"),
            new TipoCodigosProdutosANP("820101029", "ÓLEO DIESEL B S50 - COMUM"),
            new TipoCodigosProdutosANP("820101013", "ÓLEO DIESEL B S500 - ADITIVADO"),
            new TipoCodigosProdutosANP("820101012", "ÓLEO DIESEL B S500 - COMUM"),
            new TipoCodigosProdutosANP("420301003", "ÓLEO DIESEL FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("420201002", "ÓLEO DIESEL MARÍTIMO FORA DE ESPECIFICAÇÃO"),
            new TipoCodigosProdutosANP("420202001", "ÓLEO DIESEL NÁUTICO ESPECIAL - ENXOFRE 200 PPM"),
            new TipoCodigosProdutosANP("420301001", "ÓLEO DIESEL PADRÃO"),
            new TipoCodigosProdutosANP("610601001", "ÓLEOS BÁSICOS - GRUPO II"),
            new TipoCodigosProdutosANP("610701001", "ÓLEOS BÁSICOS - GRUPO III"),
            new TipoCodigosProdutosANP("510301002", "ÓLEOS COMBUSTÍVEIS PARA EXPORTAÇÃO"),
            new TipoCodigosProdutosANP("620601001", "ÓLEOS EXTENSORES E PLASTIFICANTES"),
            new TipoCodigosProdutosANP("660101001", "ÓLEOS LUB. PARAF E GRAXAS INTERMEDIÁRIOS"),
            new TipoCodigosProdutosANP("620401001", "ÓLEOS LUBRIFICANTES FERROVIÁRIOS"),
            new TipoCodigosProdutosANP("620301001", "ÓLEOS LUBRIFICANTES MARÍTIMOS"),
            new TipoCodigosProdutosANP("620201001", "ÓLEOS LUBRIFICANTES PARA AVIAÇÃO"),
            new TipoCodigosProdutosANP("630101001", "ÓLEOS LUBRIFICANTES USADOS OU CONTAMINADOS"),
            new TipoCodigosProdutosANP("320301001", "OUTRAS GASOLINAS"),
            new TipoCodigosProdutosANP("320103002", "OUTRAS GASOLINAS AUTOMOTIVAS"),
            new TipoCodigosProdutosANP("650101002", "OUTRAS GRAXAS"),
            new TipoCodigosProdutosANP("640401001", "OUTRAS PARAFINAS"),
            new TipoCodigosProdutosANP("810201002", "OUTROS ALCOÓIS"),
            new TipoCodigosProdutosANP("340101003", "OUTROS DERIVADOS LEVES"),
            new TipoCodigosProdutosANP("560101003", "OUTROS DERIVADOS PESADOS"),
            new TipoCodigosProdutosANP("210302001", "OUTROS GASES"),
            new TipoCodigosProdutosANP("210204002", "OUTROS GASES LIQUEFEITOS"),
            new TipoCodigosProdutosANP("610201004", "OUTROS NAFTÊNICOS"),
            new TipoCodigosProdutosANP("510301001", "OUTROS ÓLEOS COMBUSTÍVEIS"),
            new TipoCodigosProdutosANP("420301002", "OUTROS ÓLEOS DIESEL"),
            new TipoCodigosProdutosANP("620601004", "OUTROS ÓLEOS LUBRIFICANTES ACABADOS"),
            new TipoCodigosProdutosANP("620505001", "OUTROS ÓLEOS LUBRIFICANTES AUTOMOTIVOS"),
            new TipoCodigosProdutosANP("610501001", "OUTROS ÓLEOS LUBRIFICANTES BÁSICOS"),
            new TipoCodigosProdutosANP("620101008", "OUTROS ÓLEOS LUBRIFICANTES INDUSTRIAIS"),
            new TipoCodigosProdutosANP("610101010", "OUTROS PARAFÍNICOS"),
            new TipoCodigosProdutosANP("610302001", "OUTROS SINTÉTICOS"),
            new TipoCodigosProdutosANP("610301001", "POLIALFAOLEFINA"),
            new TipoCodigosProdutosANP("620101003", "PROCESSO"),
            new TipoCodigosProdutosANP("210201001", "PROPANO"),
            new TipoCodigosProdutosANP("210201002", "PROPANO ESPECIAL"),
            new TipoCodigosProdutosANP("210201003", "PROPENO"),
            new TipoCodigosProdutosANP("620601002", "PULVERIZAÇÃO AGRÍCOLA"),
            new TipoCodigosProdutosANP("550101001", "RESÍDUO AROMÁTICO (RARO)"),
            new TipoCodigosProdutosANP("550101005", "RESÍDUO ASFÁLTICO(RASF)"),
            new TipoCodigosProdutosANP("550101002", "RESÍDUO ATMOSFÉRICO (RAT)"),
            new TipoCodigosProdutosANP("550101003", "RESÍDUO DE VÁCUO"),
            new TipoCodigosProdutosANP("550101004", "RESÍDUO DE VÁCUO DE ALTO TEOR DE ENXOGRE"),
            new TipoCodigosProdutosANP("610101001", "SPINDLE"),
            new TipoCodigosProdutosANP("610401001", "SPINDLE RR"),
            new TipoCodigosProdutosANP("620101006", "TÊXTIL / AMACIANTE DE FIBRAS"),
            new TipoCodigosProdutosANP("620504001", "TRANSMISSÃO AUTOMÁTICA"),
            new TipoCodigosProdutosANP("620503001", "TRANSMISSÕES E SISTEMAS HIDRÁULICOS"),
            new TipoCodigosProdutosANP("610101007", "TURBINA LEVE"),
            new TipoCodigosProdutosANP("610101008", "TURBINA PESADO"),
            new TipoCodigosProdutosANP("640301001", "VASELINA"),
        ];
    }
}